import React, { memo } from "react";
import Widget from "../Widget";
import MetaTable from "components/Admin/Tables/MetaTable";

const MetasWidget = () => {
  return (
    <Widget title="Meta информация">
      <MetaTable />
    </Widget>
  );
};

export default MetasWidget;
